export default __webpack_public_path__ + "static/media/HFIL-USDT.1b24125c.svg";